import React from 'react';
import Header from './Header';
import GlobalBottomNav from './GlobalBottomNav';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <main className="flex-1 w-full py-4 pb-24">
        {children}
      </main>
      <GlobalBottomNav />
    </div>
  );
}
